import * as React from 'react';
import { MultiSelector } from '../../MultiSelector/multiSelector';
import './defaultFilters.scss';
import { useActions } from '../workspaceSettingActions';
import { useAlert } from '../../Alert/alert';
import { SchemalessFilterSchema } from '../../../utils';
import { FieldType } from '../../../enums/FieldType';
import { useSelector } from '../../../utils/useSelector';

export const DefaultFilters = () => {
  const defaultFilters = useSelector(
    s => s.planning?.selectedWorkspace?.setting?.props?.defaultFilters
  );
  const options = useSelector(s =>
    s.planning?.selectedWorkspace?.schemas
      ?.reduce<MultiSelector.Option[]>((list, schema, index) => {
        schema?.props.fields.forEach(f => {
          if (f.key == 'Item.companionBy') return;
          if (f.fieldType == FieldType.custom) return;
          list.push({ name: f.displayName, id: f.key });
        });
        if (index == s.planning?.selectedWorkspace?.schemas?.length - 1) {
          SchemalessFilterSchema.props.fields.forEach(f => {
            list.push({ name: f.displayName, id: f.key });
          });
        }
        return list;
      }, [])
      .sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()))
  );
  const [selected, setSelected] = React.useState(defaultFilters || []);
  const { save, Alert } = useAlert(useActions());
  return (
    <div className="ws-setting-content default-filters">
      <Alert />
      <div className="ws-setting-desc">
        Select and move the filters that you want to default for your workspace
      </div>
      <MultiSelector
        dual
        options={options}
        selected={selected}
        onChange={vals => {
          setSelected(vals);
          save({ defaultFilters: vals });
        }}
        headers={['All Filters', 'Selected Filters (Default)']}
      />
    </div>
  );
};
